import {PrintSiarFormSchema} from '@/features/projects/formSchemas'
import {ProjectStatus} from '@/features/projects/types'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const PrintSiarFormProvider = ({
    children,
    projectId,
    projectStatus
}: {
    children: ReactNode
    projectId: string
    projectStatus: ProjectStatus
}) => {
    const form = useForm<PrintSiarFormSchema>({
        resolver: zodResolver(PrintSiarFormSchema),
        defaultValues: {
            categorySection: projectStatus == 'closed' ? 'close_project' : 'open_project',
            hasSignature: false,
            projectId
        }
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
